export { PartnerPromo } from './PartnerPromo';
